import { themeColors } from "@/utils/themeColors";
import { useRef } from "react";

type Props = {
    word: string;
    onClick: () => void;
    highlighted: boolean;
};

export const TranscriptWord = ({ word, onClick, highlighted }: Props) => {
    const ref = useRef<HTMLSpanElement>(null);

    return (
        <span
            ref={ref}
            data-highlighted={highlighted}
            style={{
                scrollMarginBlock: "2.5rem",
                borderRadius: "0.4rem",
                cursor: "pointer",
                ...(highlighted
                    ? {
                          color: themeColors.pureBlack,
                          backgroundColor: themeColors.primaryLight,
                          outlineColor: themeColors.primaryLight,
                          outlineStyle: "solid",
                          outlineWidth: "4px",
                      }
                    : {}),
            }}
            onClick={onClick}>
            {word}
        </span>
    );
};
